<ngx-loading [show]="loading" [config]="{ backdropBorderRadius: '3px' ,fullScreenBackdrop:true}"></ngx-loading>
<div class="wrapper">
    <app-sidebar></app-sidebar>
    <app-header></app-header>
    <div class="page-wrapper">
        <div class="page-content">
            <!--breadcrumb-->
            <div class="page-breadcrumb d-sm-flex align-items-center mb-4">
                <!-- <div class="breadcrumb-title pe-3"><span [translate]="'GREATER.COLLABRATORS'"> </span></div> -->
                <div class="ps-3">
                    <nav aria-label="breadcrumb">
                        <ol class="breadcrumb mb-0 p-0">
                            <li class="breadcrumb-item"><a href="javascript:void(0);" routerLink="/dashboard" ><i class="bx bx-home-alt"></i></a>
                            </li>
                            <!-- <li class="breadcrumb-item active" aria-current="page"><span [translate]="'GREATER.COLLABRATORS'"> </span></li> -->
                        </ol>
                    </nav>
                </div>
                <div class="ms-auto">
                    <div class="btn-group">
                        <!-- <button type="button" class="btn brandpurpal-btn split-bg-primary dropdown-toggle dropdown-toggle-split" data-bs-toggle="dropdown">	<span>Toggle Dropdown</span>
                        </button>
                        <div class="dropdown-menu dropdown-menu-right dropdown-menu-lg-end"> <a class="dropdown-item" href="javascript:void(0)"><span [translate]="'GREATER.LOW'"> </span></a>
                            <a class="dropdown-item" href="javascript:void(0)">Another action</a>
                            <a class="dropdown-item" href="javascript:void(0)">Something else here</a>
                            <div class="dropdown-divider"></div> <a class="dropdown-item" href="javascript:void(0)">Separated link</a>
                        </div> -->
                    </div>
                </div>
            </div>
            <!--end breadcrumb-->

            <div class="row">
                   <div class="col-3 col-md-3 pb-3">
                    <label for="inputState" class="form-label"><span [translate]="'GREATER.SEARCH_NAME_EMAIL'"> </span></label>
                    <input type="text" id="inputState" class="form-control" placeholder="{{ 'GREATER.SEARCH_NAME_EMAIL' | translate }}" [(ngModel)]='searchKey' (keyup)="p=1;getDetail(p)">
                </div>  
                    <div class="col-3 col-md-3 pb-3">
                    <label for="inputState" class="form-label"><span [translate]="'GREATER.TYPE'"> </span></label>
                    <select id="inputState" class="form-select" [(ngModel)]='searchKey1' (change)="p=1;getDetail(p)">
                        <option value="" selected hidden disabled><span [translate]="'GREATER.SELECT'"> </span></option>
                        <option value="2"><span [translate]="'GREATER.ORGANISATION'"> </span></option>
                        <option value="3"><span [translate]="'GREATER.CREATORS'"> </span></option>
                        <option value="4"><span [translate]="'GREATER.CUSTOMERS'"> </span></option>
                    </select>
                </div>    
                 <div class="col-3 col-md-3 pb-3 pt-4">
                    <button type="button" class="btn custom-btn brand-btn2 px-4" (click)="reset()"><span [translate]="'GREATER.RESET'"> </span></button>
                </div>     
                <!-- <div class="col-2 pb-3" *ngIf="dataListing.length > 0">
                    <label for="inputState" class="form-label"><span [translate]="'GREATER.LIMIT'"> </span></label>
                    <select id="inputState" class="form-select" [(ngModel)]='pageLimit' (change)="p=1;p=1;getDetail(p)">
                    <option *ngFor="let item of service.LimitArray">{{item}}</option>
                    </select>                   
                </div> -->
                <div class="col-12">
                    <div class="card">
                        <div class="card-body">
                            <div class="card-title d-flex align-items-center">
                                <h5 class="mb-2" ><span [translate]="'GREATER.COLLABRATORS'"> </span></h5>
                            </div>
                            <hr>
                            <table class="table mb-0 table-hover">
                                <thead>
                                    <tr>
                                        <th scope="col"><span [translate]="'GREATER.NO'"> </span>.</th>
                                        <th scope="col"><span [translate]="'GREATER.CREATORS'"> </span></th>
                                        <th scope="col"><span [translate]="'GREATER.ORGANISATION'"> </span></th>
                                        <th scope="col"><span [translate]="'GREATER.REVENUE_SHARE'"> </span></th>
                                                                                <th scope="col" class="d-flex"><span [translate]="'GREATER.DATE'"></span> 
                                           <span style="cursor: pointer;" class="ms-2"> <i class="bx bx-arrow-to-top" (click)="sortType='asc';p=1;getDetail(p)"></i> <i class="bx bx-arrow-to-bottom" (click)="sortType='desc';p=1;getDetail(p)"></i></span>  </th>

                                        <th scope="col"><span [translate]="'GREATER.STATUS'"> </span></th>
                                        <th scope="col"><span [translate]="'GREATER.ACTIONS'"> </span></th>

                                    </tr>
                                </thead>
                                <tbody>
                                    <tr *ngFor="let item of DataListing | paginate: { itemsPerPage: pageLimit, currentPage: p, totalItems: totalCount}; let i = index ">
                                        <td scope="row">{{(pageLimit * (p - 1)) + i + 1 }}</td>
                                        <td>{{item.creator}}</td>
                                        <td>{{item.organization}}</td>
                                        <td>{{item.revenue_share}}%</td> 
                                        <td>{{service.dateCon(item.createdAt)}}</td>                                    
                                        <td>
                                            <div>
                                                <span class="badge bg-success" *ngIf="item.status =='Active' ">{{item.status}}</span>
                                                <span class="badge bg-info" *ngIf="item.status == 'Pending'">{{item.status}}</span>
                                            </div>
                                        </td> 
                                        <td>
                                            <div class="btn-group" role="group" aria-label="Basic example">
                                                <button type="button" class="btn btn-danger text-center" title="Delete"  (click)="redirect(item,2)">
                                                    <i class="bx bx-trash"></i>
                                                </button>
                                            </div>
                                        </td>                                      
                                    </tr>
                                </tbody>
                            </table>
                            <div class="pagination-block pt-5">
                                <pagination-controls [previousLabel]="previousLabel" [nextLabel]="nextLabel" (pageChange)="getDetail((p = $event))" class="text-center" *ngIf="DataListing.length > 0"></pagination-controls>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <!--end row-->
        </div>
    </div>
    <app-footer></app-footer>
</div>
